import { rankingData } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-green-500',
  hot: 'ri-fire-line text-red-500',
  new: 'ri-sparkling-line text-accent-500',
  stable: 'ri-subtract-line text-foreground-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热度排行榜</h2>
          <p className="text-foreground-600">站内最受关注的影视作品实时排行</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item, index) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-3 md:gap-4 px-4 py-3.5 hover:bg-background-100 rounded-lg transition-colors duration-200 border-b border-background-200/60 last:border-b-0 cursor-pointer no-underline group"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm font-bold flex-shrink-0 ${
                index < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">{item.title}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-bold text-primary-500 font-heading">{item.heat}</span>
                <i className={trendIcons[item.trend] || 'ri-subtract-line text-foreground-500'}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}